import { FC, SVGProps } from 'react'

export const CheckedCircle: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20C15.5229 20 20 15.5229 20 10C20 4.47715 15.5229 0 10 0C4.47705 0 0 4.47715 0 10C0 15.5229 4.47705 20 10 20ZM14.0303 8.53033C14.3232 8.23743 14.3232 7.76257 14.0303 7.46967C13.7373 7.17677 13.2627 7.17677 12.9697 7.46967L8.95654 11.4828L7.53027 10.0566C7.2373 9.76373 6.7627 9.76373 6.46973 10.0566C6.17676 10.3495 6.17676 10.8244 6.46973 11.1173L8.42627 13.0738L8.95654 13.6041L9.48682 13.0738L14.0303 8.53033Z"
      fill="currentColor"
    />
  </svg>
)
